import ActionTypes from '../constants/ActionTypes';

/* Events */

export const fetchSettingPricesRequested = (name) => ({
  type: ActionTypes.SETTING_PRICES_FETCH_REQUESTED,
  payload: {
    name,
  },
});

export const fetchSettingPricesSucceeded = (name, data) => ({
  type: ActionTypes.SETTING_PRICES_FETCH_SUCCEEDED,
  payload: {
    name,
    data,
  },
});

export const fetchSettingPricesFailed = (error) => ({
  type: ActionTypes.SETTING_PRICES_FETCH_FAILED,
  payload: {
    error,
  },
});
